export default __webpack_public_path__ + "static/media/54t.a4fca868.jpg";